
import store from "../store";
import * as types from "./constants";
import { ADD_PHOTO_POST } from "../photos/constants";
import { ADD_FEED_POST } from "../activity-feed/constants";
import { getPhotoPostsById } from "../photos/actions";
import { handleCaptcha, renderAjaxErrorModal } from '../utils';

export function uploadPhoto(files, photoComment = "", tags = [], mentions = [], captcha = null) {
  setIsUploading(true);

  let promises = [];
  let numberOfUrlsToComplete = files.length;
  let completed = 0;

  return new Promise(function (resolve, reject) {
    _fetchUploadURLs(numberOfUrlsToComplete)
      .then((urls) => {
        for(let i = 0; i < files.length; i++) {
          const file = files[i];
          if (!file.type.match('image.*')) {
            numberOfUrlsToComplete--;
            continue;
          }
          promises.push(_preparePhoto(file, urls[i]));
        }

        Promise.all(promises)
          .then((photoIds) => {
            _createPost(photoIds, photoComment, tags, mentions, captcha)
              .then(resolve);
          })
          .catch(reject);
      })
      .catch(reject);
  })
    .catch(({ jqXHR, textStatus, errorThrown }) => {
      if(textStatus !== 'abort'){
        renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
      }

      resetFileUploader();
    });

  function _fetchUploadURLs(numberOfUrls) {
    const url = `/ajax/event/${window.evite_event.id}/posts/photo-upload-urls/?gid=${window.guest_id}`;
    return new Promise((resolve, reject) => {
      $
        .post(url, { number_of_urls: numberOfUrls })
        .done(resolve)
        .fail((jqXHR, textStatus, errorThrown) => {
          reject({ jqXHR, textStatus, errorThrown });
        })
    });
  }


  // Prepare Photo
  function _preparePhoto(file, uploadUrl) {
    let formData = new FormData();
    formData.append('photo', file, 'image');
    return new Promise((resolve, reject) => {
      window.uploadXhr = window.$.ajax({
          url: uploadUrl,
          data: formData,
          type: 'POST',
          cache: false,
          contentType: false,
          processData: false,
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          reject({ jqXHR, textStatus, errorThrown });
        })
        .done(function (response) {
          completed++;
          const percentComplete = Math.ceil((completed / numberOfUrlsToComplete) * 100);
          setUploadProgress(percentComplete);
          const photo_id = response.photo_id;
          resolve(photo_id);
        });
    });
  }

  function _createPost(photoIds, photoComment, tags, mentions, captcha) {
    const url = `/ajax/event/${window.evite_event.id}/posts/photos/?gid=${window.guest_id}`;
    let formData = new FormData();
    formData.append('photo_ids', JSON.stringify(photoIds));
    if (photoComment) {
      formData.append('comment', photoComment.trim());
    }
    if (tags) {
      formData.append('tags', JSON.stringify(tags));
    }
    if (mentions) {
      formData.append('mentions', JSON.stringify(mentions));
    }
    if (captcha) {
      formData.append('captcha', captcha);
    }

    return new Promise(function (resolve) {
      window.uploadXhr = window.$.ajax({
          url: url,
          data: formData,
          type: 'POST',
          cache: false,
          contentType: false,
          processData: false,
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          handleCaptcha(jqXHR, textStatus, errorThrown, (captcha) => {
            _createPost(photoIds, photoComment, tags, mentions, captcha).then(resolve);
          });
        })
        .done(function (response) {
          store.dispatch({
            type: ADD_FEED_POST,
            post: response
          });
          if (response.post_type === "multi_photo") {
            let postIds = [];
            for(let i = 0; i < response.content.objects.length; i++) {
              postIds.push(response.content.objects[i].id);
            }
            getPhotoPostsById(JSON.stringify(postIds));
          } else {
            store.dispatch({
              type: ADD_PHOTO_POST,
              post: response
            });
          }
          window.dataLayer.push({ 'event': 'postphoto', 'photoCount': files.length });

          resolve(response);
        })
        .always(resetFileUploader);
    });
  }
}

export function cancelUpload() {
  resetFileUploader();
  if (window.uploadXhr) {
    window.uploadXhr.abort();
    window.uploadXhr = null;
  }
}

export function setUploadProgress(percentComplete) {
  store.dispatch({
    percentComplete,
    type: types.SET_UPLOAD_PROGRESS,
  });
}

export function setIsUploading(isUploading) {
  setUploadProgress(0);
  store.dispatch({
    isUploading,
    type: types.SET_IS_UPLOADING,
  });
}

export function addFileToStage(file) {
  store.dispatch({
    file,
    type: types.ADD_STAGED_FILE,
  });
}

export function removeFileFromStage(file) {
  store.dispatch({
    file,
    type: types.REMOVE_STAGED_FILE,
  });
}

export function addFileToSelection(file) {
  store.dispatch({
    file,
    type: types.ADD_SELECTED_FILE,
  });
}

export function removeFileFromSelection(file) {
  store.dispatch({
    file,
    type: types.REMOVE_SELECTED_FILE,
  });
}

export function resetFileUploader() {
  store.dispatch({
    type: types.RESET_FILE_UPLOADER
  })
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/file-uploader/actions.es6